<template>
  <SysDataTableExpand
    :headers="CABECALHOS_COMPUTED"
    :height="alturaDaJanela - 120"
    :item-height="45"
    :callbacks="CALLBACKS"
    hide-default-footer
    :hide-border-bottom-tr="false"
    :item-class="classesCssLinha"
    @callback-resetar-grid="fn => callbackResetarGrid = fn"
    @dblclickRow:row="ev => linha_duplamente_clicada = ev.row"
  >
    <template #top>
      <div class="d-flex align-center w-full py-3">
        <span class="font-20 font-weight-medium text-systock-blue">Movimentação do Estoque</span>

        <v-divider vertical class="mx-4" />

<!--        <Filtros v-model="filtros_gerais" :size="3" @update:filtros="callbackResetarGrid()" />-->

        <FiltrosUniversalAvancado
            v-model="filtros_gerais"
            :size="3"
            @update:filtros="callbackResetarGrid()"
        />

        <FiltroPeriodoAnalise
          :data_inicial_atual="periodo_analise.data_inicial"
          :data_final_atual="periodo_analise.data_final"
          @update:periodo-analise="callbackResetarGrid()"
        />

        <HistoricoMovimentacao class="ml-4" />

        <DetalhamentoDuploClique
          :linha="linha_duplamente_clicada"
          :filtros="filtros_gerais"
          :periodo_analise="periodo_analise"
          ativar_dialog_em_mudanca_linha
          @dialog-fechado="linha_duplamente_clicada = null"
        />
      </div>
    </template>

    <template #_item.descricao_linha="{item}">
      <div class="d-flex align-center text-left">
        <DetalhesProduto 
          v-if="item.idproduto"
          :produto="{id_grupo: item.idgrupo, id_filial: 9999, id_produto: item.idproduto, produto_eh_combinacao: item.produto_combinado}" 
        />
        <div class="w-400 text-truncate" :title="item.descricao_linha" v-text="item.descricao_linha" />
      </div>
    </template>
  </SysDataTableExpand>
</template>

<script>
import {componentes} from "@/components/Diagnostico/SlowNoMoving/MovimentacaoEstoque/Tabela/Componentes";
import ResponsiveHeight from "@/helpers/ResponsiveHeight";
import {cabecalhos} from "@/components/Diagnostico/SlowNoMoving/MovimentacaoEstoque/Tabela/Cabecalhos";
import * as api from "@/api/Diagnostico/SlowNoMoving/MovimentacaoEstoque";
import {formatarValor, formatarValorMonetario} from "@/helpers";
import store from "@/store";

export default {
  name: "TabelaMovimentacaoEstoque",
  mixins: [ResponsiveHeight],
  components: componentes,
  props: {
    indicador_evolucao: {
      type: Boolean,
      required: false
    },
    filtros_iniciais: {
      type: Object,
      required: false
    },
  },
  data: () => ({
    callbackResetarGrid: null,
    periodo_analise: {
      data_inicial: '00/00/0000',
      data_final: '00/00/0000',
    },
    linha_duplamente_clicada: null,
    items_props_produtos_pendentes: [
      { id: 1, descricao: '1. Produtos sem Pedido Pendente' },
      { id: 2, descricao: '2. Produtos com Pedido Pendente' },
    ]
  }),
  mounted() {
    if (this.indicador_evolucao) {
      const { compradores, segmentos, fornecedores, status_produto, pedidos_pendentes, produtos } = this.filtros_iniciais;

      this.filtros_gerais = {
        ...this.filtros_gerais,
        status_produto: ['1. Excesso', ...status_produto],
        compradores,
        segmentos,
        fornecedores,
        pedidos_pendentes,
        produtos,
      };
    }
  },
  computed: {
    CABECALHOS_COMPUTED() {
      const callback = item => ({
        ...item,
        text: item.text.replaceAll("{data_inicial}", this.periodo_analise.data_inicial)
          .replaceAll("{data_final}", this.periodo_analise.data_final)
      });

      return cabecalhos.map(callback);
    },
    CALLBACKS() {
      const funcoes = [
        this.buscarStatusMovimentacao,
        this.buscarSegmentos,
        this.buscarFornecedores,
        this.buscarProdutos,
      ];

      if (localStorage.diagnostico_ocultar_nivel_fornecedor === 'S') {
        return funcoes.filter(f => f !== this.buscarFornecedores);
      }

      return funcoes;
    },
    filtros_gerais() {
      return store.getters['filtrosUniversalAvancado/filtros_formatados'];
    }
  },
  methods: {
    formatarValorMonetario,
    formatarItensParaGrid(itens, campos_extras = {}) {
      const callback = item => ({
        ...campos_extras,
        ...item,
        qtde_produtos: item.qtde_produtos > 0 ? formatarValor(item.qtde_produtos) : '-',
        percentual: item.percentual > 0 ? `${formatarValor(item.percentual)}%` : '-',
        estoque_em_preco_custo: formatarValorMonetario(item.estoque_em_preco_custo),
        estoque_ideal_em_preco_custo: formatarValorMonetario(item.estoque_ideal_em_preco_custo),
        diferenca_em_preco_custo: formatarValorMonetario(item.diferenca_em_preco_custo),
        crescimento_em_preco_custo: formatarValorMonetario(item.crescimento_em_preco_custo),
      });
      return itens.map(callback);
    },
    gerarValoresTotalizados(itens) {
      const callback = (a, b) => {
        cabecalhos.filter(item => item.totalizar).forEach(({ value }) => a[value] = (a[value] || 0) + Number(b[value]));
        return a;
      };

      return {
        ...itens.reduce(callback, {}),
        descricao_linha: "Total Geral",
        percentual: 100,
        totalizador: true,
        $nao_expansivel: true,
      };
    },
    async buscarStatusMovimentacao() {
      const { itens, periodo_analise } = await api.buscarStatusMovimentacao(this.filtros_gerais);
      this.periodo_analise = periodo_analise;
      return this.formatarItensParaGrid([this.gerarValoresTotalizados(itens), ...itens]);
    },
    async buscarSegmentos({ id_status_movimentacao, descricao_linha: status_movimentacao }) {
      const filtros = {
        ...this.filtros_gerais,
        id_status_movimentacao
      };

      const segmentos = await api.buscarSegmentos(filtros);

      return this.formatarItensParaGrid(segmentos, { status_movimentacao });
    },
    async buscarFornecedores(linha) {
      if (linha.descricao_linha === 'COMBINADOS') {
        linha.produto_combinado = true;
        return await this.buscarProdutos(linha);
      }

      const filtros = {
        ...this.filtros_gerais,
        id_status_movimentacao: linha.id_status_movimentacao,
        segmentos: [linha.idsegmento],
      };

      const fornecedores = await api.buscarFornecedores(filtros);

      const campos_extras = {
        status_movimentacao: linha.status_movimentacao,
        descricao_segmento: linha.descricao_linha,
      };

      return this.formatarItensParaGrid(fornecedores, campos_extras);
    },
    async buscarProdutos(linha) {
      const filtros = {
        ...this.filtros_gerais,
        id_status_movimentacao: linha.id_status_movimentacao,
        segmentos: [linha.idsegmento],
        fornecedores: linha.idfornecedor ? [linha.idfornecedor] : [],
        produto_combinado: linha.produto_combinado ? 'S' : 'N'
      };

      const produtos = await api.buscarProdutos(filtros);
      produtos.forEach(produto => {
        produto.$nao_expansivel = linha.produto_combinado;
        produto.produto_combinado = linha.produto_combinado;
      });

      const campos_extras = {
        status_movimentacao: linha.status_movimentacao,
        descricao_segmento: linha.descricao_segmento,
        descricao_fornecedor: linha.descricao_linha
      };

      return this.formatarItensParaGrid(produtos, campos_extras);
    },
    classesCssLinha(linha) {
      return {
        'font-weight-bold': linha.totalizador,
        'font-weight-bold-hover': true
      };
    },
  }
}
</script>
